import { Component, type ReactNode } from "react";
import { RefreshCw } from "lucide-react";

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  isChunkError: boolean;
}

export class LazyErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false, isChunkError: false };

  static getDerivedStateFromError(error: Error): State {
    const isChunkError =
      error.name === "ChunkLoadError" ||
      error.message.includes("Failed to fetch dynamically imported module") ||
      error.message.includes("Loading chunk") ||
      error.message.includes("Loading CSS chunk");

    return { hasError: true, isChunkError };
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (!this.state.hasError) {
      return this.props.children;
    }

    return (
      <div className="flex flex-col items-center justify-center py-16 px-4 text-center">
        <div className="rounded-full bg-muted p-4 mb-4">
          <RefreshCw className="h-8 w-8 text-muted-foreground" />
        </div>

        {this.state.isChunkError ? (
          <>
            <h2 className="text-lg font-semibold mb-2">
              Dostępna nowa wersja aplikacji
            </h2>
            <p className="text-muted-foreground mb-6 max-w-md">
              Aplikacja została zaktualizowana. Odśwież stronę, aby załadować
              najnowszą wersję.
            </p>
          </>
        ) : (
          <>
            <h2 className="text-lg font-semibold mb-2">
              Nie udało się załadować strony
            </h2>
            <p className="text-muted-foreground mb-6 max-w-md">
              Wystąpił błąd podczas ładowania. Sprawdź połączenie z internetem
              i spróbuj ponownie.
            </p>
          </>
        )}

        <button
          onClick={this.handleReload}
          className="inline-flex items-center gap-2 rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground hover:bg-primary/90 transition-colors"
        >
          <RefreshCw className="h-4 w-4" />
          Odśwież stronę
        </button>
      </div>
    );
  }
}
